
import { computed, Ref, ref } from '@nuxtjs/composition-api';
import { useQuery } from '@vue/apollo-composable';

import { fullSizedImageQuery } from '@/graphql/queries/image';
import type { ImageQuery, ImageQueryVariables } from '@/graphql/generated';

export const useFullSizedImage = (id?: string, enabled: Ref<boolean> = ref(true)) => {
  const imageId = ref(id || null);
  const { result, loading } = useQuery<ImageQuery, ImageQueryVariables>(
    fullSizedImageQuery,
    () => ({ id: imageId.value }),
    () => ({ enabled: imageId.value && enabled.value }),
  );

  return {
    imageId,
    image: computed(() => result.value?.image),
    imageLoading: loading,
  };
};
